import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, showingPageTotalRange, unexpectedError, filter } from '../../common_functions';

const Date_Confidences = props => {
  const [confidence, setconfidence] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Date Confidence',
      dataIndex: 'date_confidence',
      key: 'date_confidence',
      sorter: true,
      ...filter('date_confidence'),
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
      // sorter: true,
      ...filter('value'),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      sorter: true,
      ...filter('description'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/date-confidence/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_date_confidence?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_date_confidence?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'date_confidence',
              'Date confidence?',
              confidence,
              setconfidence,
              props?.tabs_permissions?.settings_date_confidence?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  useEffect(() => {
    (async () => {
    await getDateConfidences(pagination);
  })();
  }, []);
  const getDateConfidences = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);

      const response = await props.getItems('date_confidence', {
        fields: ['id', 'date_confidence', 'description', 'value'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });

      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setconfidence(response.data);
    } catch (error) {
      console.error(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          filtersitems[key] = { _icontains: val[0] };
        }
      }
    }
    await getDateConfidences(pagination, filtersitems, sorter);
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/date-confidence" }, { title: "Date Confidence" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Date Confidence
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_date_confidence,
                '/settings/date-confidence/new',
                'Add New Date Confidence'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={confidence}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Date_Confidences;
